import firebase, { firestore, functions, auth } from "firebase";
import * as uuid from 'uuid'
import * as D from './personal'
import * as U from '../util'
import _ from 'lodash';

function isTimestamp(arg: any): arg is firestore.Timestamp {
  if (arg && typeof arg === "object") {
    if (typeof arg.seconds === "number" && typeof arg.nanoseconds === "number") {
      return true
    }
  }
  return false
}

const itemColname: { [P in D.ItemCategory]: string } = {
  Slip: "slip",
  Schedule: "schecule",
  Task: "task",
};

/**
 * XのキーのうちProtected**以外**を省略可能とする
 */
type PartialPartial<X,Protected extends keyof X> = Pick<X, Protected> & Partial<Omit<X, Protected>>

type EditablePart<U, Keys extends keyof U> = Omit<U, Keys>
type AutoSetPart<U, Keys extends keyof U> = Pick<U, Keys>
type AutoSetKeys = "id" | "authorId" | "resolved" | "resolvedTime" | "pinned" | "createdTime" | "updatedTime"

export class ItemDocument {
  static skeltonTask(): EditablePart<D.TaskItem, AutoSetKeys> {
    return {
      category: "Task",
      title: "",
      deadlineTime: undefined,
      desc: undefined,
      wip: false,
    }
  }

  private static autosetter<T extends D.Item>(): AutoSetPart<T, AutoSetKeys> {
    const t = new Date();
    return {
      id: t.getTime().toString() + "_" + uuid.v4(),
      authorId: this.userId,
      resolved: false,
      createdTime: t,
      updatedTime: t,
    }
  }


  public static async create<T extends D.Item>(item: EditablePart<T, AutoSetKeys>) {
    const astd = this.autosetter<T>();
    return this.collection(item.category).doc(astd.id).set(_.mapValues({
      ...item,
      ...astd,
    }, (v) => _.isUndefined(v) ? null : v), { merge: true })
  }

  public static async update<T extends D.Item>(item: T) {
    console.log(item)
    return this.collection(item.category).doc(item.id).set(_.mapValues({
      ...item,
    }, (v) => _.isUndefined(v) ? null : v), { merge: true })
  }

  static deserialize<T extends D.ItemCategory>(doc: firestore.DocumentSnapshot): D.ReverseCategory[T] {
    const data: {
      [K in keyof D.ReverseCategory[T]]: any
    } = (doc.data()! as any)
    return _.mapValues(data, (v: any) => {
      if (v instanceof firestore.Timestamp) {
        return v.toDate()
      }
      return _.isNull(v) ? undefined : v
    }) as D.ReverseCategory[T]
  }

  static get userId(): string {
    const u = auth().currentUser
    if (!u) { throw { message: "not authorized" } }
    return u.uid
  }

  public static collection(category: D.ItemCategory) {
    return firebase.firestore().collection("users").doc(this.userId).collection(itemColname[category])
  }

  public static subscribe(callback: (d: firestore.DocumentChange) => void) {
    return this.collection("Task")
      .limit(100)
      .orderBy("createdTime", "desc")
      .onSnapshot(snapshot => snapshot.docChanges().forEach(callback))
  }

  public static resolve<T extends D.Item>(item: T, resolve: boolean) { 
    const arg: any = { resolved: resolve };
    if (resolve) { 
      arg.resolvedTime = new Date()
      arg.wip = false
    }
    return this.collection(item.category).doc(item.id).update(arg);
  }

  public static pin<T extends D.Item>(item: T, pin: boolean) { 
    const arg: any = { pinned: pin };
    return this.collection(item.category).doc(item.id).update(arg);
  }
}